import httpService from "@/services/httpService";
import pagingService from "./pagingService";

export default {
  search: async (mustBeActive, query, partyTypeId, partyStatus, options, filterVendorsOnly = false) => {
    return httpService.get(
      `/party/grid/search?${
        mustBeActive ? "isActive=true&" : ""
      }partyStatus=${partyStatus}&${pagingService.toQueryString(options)}&query=${query || ""}&partyTypeId=${
        partyTypeId === -1 ? "" : partyTypeId
      }${filterVendorsOnly ? "&filterVendorsOnly=true" : ""}`
    );
  },
  get: async id => httpService.get(`/party/${id}`),
  getByIdWithConnectedOrgUnits: async id => httpService.get(`/party/getByIdWithConnectedOrgUnits/${id}`),
  connect: async (id, orgUnitId = null) =>
    httpService.put(`/party/${id}/connect${orgUnitId ? `?orgUnitId=${orgUnitId}` : ""}`),
  connectAndCreateOrgUnit: async (id, orgUnit) => httpService.put(`/party/${id}/connectAndCreateOrgUnit`, orgUnit),
  disconnect: async (id, deleteRelationship) =>
    httpService.post(`/party/${id}/disconnect?deleteRelationshipAndNotifyConnections=${deleteRelationship}`),
  reconnect: async id => httpService.put(`/party/${id}/reconnect`),
  invite: async id => httpService.put(`/party/${id}/invite`),
  create: async party => httpService.post("/party", party),
  update: async party => httpService.put(`/party/${party.id}`, party),
  delete: async id => httpService.deleteRequest(`/party/${id}`),
  getPartyTypesByCompanyId: async companyId => httpService.get(`/party/partyTypesByCompanyId/${companyId}`),
  checkupPartyAlreadyConnected: async id => httpService.get(`/party/${id}/checkAlreadyConnected`),
  getPartiesByOrgUnitId: async orgUnitIds => httpService.get(`/party/partiesByOrgUnitId/${orgUnitIds}`),
  getPartyNetworkMatches: async () => httpService.get(`/party/searchForPartyNetworkMatchesCount`),

  formatAddress: party => {
    if (!party) return "";

    var result = [];

    var addIfDefined = function(input) {
      if (input && input !== "NULL") result.push(input);
    };

    addIfDefined(party.addressLineOne);
    addIfDefined(party.city);
    addIfDefined(party.state);

    return result.join(", ");
  },
  getChatParties: async () => httpService.get(`/party/getChatParties`),
};
